import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Se as linhas acima falharem em ler as chaves, a linha abaixo
// fará com que 'supabase' se torne 'undefined', causando o erro.
export const supabase = createClient(supabaseUrl, supabaseKey);